module.exports = __webpack_public_path__ + "static/media/VeroSource-logo.1cb5c937.png";